import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoaderService } from '../services/loader.service';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);
  const urlsToExclude: string[] = [];
  const isAutoRefresh = req.headers.get('X-Auto-Refresh') === 'true';
  const showMainLoader =
    !urlsToExclude.includes(req.url) && !isAutoRefresh;

  if (showMainLoader) {
    loaderService.ongoingRequests.update(current => ++current);
  }

  return next(req).pipe(
    finalize(() => {
      if (showMainLoader && loaderService.ongoingRequests() > 0) {
        loaderService.ongoingRequests.update(current => --current);
      }
    })
  );
};
